<template>
  <div class="item" @click="goDetail" v-if="item">
    <div class="item-img" :style="{ backgroundImage: 'url(' + item.cover_img + ')' }">
      <img :src="item.cover_img" alt="" @error="imgError(item)">
      <div class="defaultRedBtnBox" v-if="item.award">
        <div class="defaultRed-btn">
          <div class="btn item-tips ellipsis">{{ item.award }}</div>
        </div>
      </div>
      <div class="item-play" v-if="item.good_show_type">
        <span class="iconfont icon-video" v-if="item.good_show_type == '视频'"></span>
        <span class="iconfont icon-voiceprint-line" v-else-if="item.good_show_type == '音频'"></span>
        <span class="iconfont icon-tupian" v-else-if="item.good_show_type == '图片'"></span>
      </div>
    </div>
    <div class="item-txt">
      <div class="item-title">
        <h3 class="ellipsis" :title="item.name">{{ item.name }}</h3>
      </div>
      <div class="item-sub">
        <span v-if="item.type_tag_name">{{ item.type_tag_name | formatShowFirst }}</span>
        <span v-if="item.show_time">{{ item.show_time | formatStandardDate }}</span>
      </div>
      <p class="item-look" v-if="item.look_count">
        <em class="iconfont icon-attention"></em>
        <i>{{ item.look_count }}</i>
      </p>
    </div>
  </div>
</template>

<script>
import colums from '../../colums/colums.js'
export default {
  name: 'programItem',
  props: {
    item: Object,
    access: String,
    newWindow: Boolean
  },
  data() {
    return {
      colums: colums.jmkcate
    }
  },
  mounted() {

  },
  methods: {
    goDetail() {

      let hash = ''
      if (this.access == 0) {
        hash = this.$utils.hashNum(this.access)
      } else {
        hash = this.$utils.hashNum(this.item.no_access)
      }

      let matchObj = this.colums.find(newitem => { return newitem.id == this.item.type_id })

      try {
        if (this.$route.meta.detailPage && !this.newWindow) {
          this.$router.push({
            path: matchObj.path + "/" + this.item.id + "/" + hash,
          })
          return
        }
        let link = this.$router.resolve({
          path: matchObj.path + "/" + this.item.id + "/" + hash,
        })
        window.open(link.href, '_blank')
      } catch (error) {
        this.$router.push({
          path: matchObj.path + "/" + this.item.id + "/" + hash,
        })
      }

    }
  }
}
</script>
<style scoped >
.item .item-img {
  background: #f3f3f3 center center no-repeat;
  background-size: cover;
}

.item .item-img img {
  opacity: 0;
}</style>